import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Image from '../Image/Image';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import classnames from 'classnames';

function Icon({ iconName, alt }) {
    return (
        <div className='uk-flex uk-flex-center'>
            {/* {iconName === 'visa-mastercard' ? (
                <Image
                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/payment/${iconName}.png`}
                    alt={alt}
                    resizeWidth={120}
                    resizeHeight={70}
                    fit="contain"
                    enlarge={true}
                    background="transparent"
                />
            ) : ( */}
            <Image
                src={`https://techno-images.s3.eu-central-1.amazonaws.com/payment/${iconName}.png`}
                alt={alt}
                resizeWidth={70}
                resizeHeight={70}
                fit="contain"
                enlarge={true}
                background="transparent"
            />

        </div>
    );
}

function IconWithAbgewikelt({ iconName, alt }) {
    return (
        <div className='uk-flex uk-flex-center'>
            {iconName === 'visa-mastercard-sepa' ? (
                <Image
                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/payment/${iconName}.png`}
                    alt={alt}
                    resizeWidth={200}
                    resizeHeight={90}
                    fit="contain"
                    enlarge={true}
                    background="transparent"
                />
            ) : (
                <Image
                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/payment/${iconName}.png`}
                    alt={alt}
                    resizeWidth={130}
                    resizeHeight={90}
                    fit="contain"
                    enlarge={true}
                    background="transparent"
                />
            )}
        </div>
    );
}

const gridClass = (num) => num % 2 === 0 ? 'uk-child-width-1-2' : 'uk-child-width-1-3';


function PaymentColumns() {
    const markenStandort = useSelector(markenStandortSelector);
    const [totalPaymentIcon, settotalPaymentIcon] = useState(0);
    const [totalShippingIcon, settotalShippingIcon] = useState(0);

    const isPaypalService = markenStandort.paymentProvider === 'paypal' && !!markenStandort?.paypalClientId;
    const isPayOneService = !!markenStandort?.stammblatt?.payone?.aid;

    const arrayWithPaymentIconNames = useMemo(() => {
        const shippingPaymentCategories = _.get(markenStandort, 'stammblatt.zahlungsarten.versand', []);
        const shippingPaymentCategoriesPaypal = _.get(markenStandort, 'stammblatt.zahlungsarten.versandPaypal', []);
        const PPE = _.get(markenStandort, 'stammblatt.subZahlungsarten.PPE', false);
        const PDT = _.get(markenStandort, 'stammblatt.subZahlungsarten.PDT', false);
        let arrayWithPaymentIconNames = [];
        if (isPaypalService) {
            arrayWithPaymentIconNames = _.flatMap(shippingPaymentCategoriesPaypal, 'picturePath');
        } else if (isPayOneService) {
            arrayWithPaymentIconNames = _.flatMap(shippingPaymentCategories, 'picturePath');
        }
        arrayWithPaymentIconNames = arrayWithPaymentIconNames?.filter(path => (PDT || path !== '/paydirekt')); //&& (PPE || path !== '/paypal')
        //arrayWithPaymentIconNames = [...arrayWithPaymentIconNames, ...(markenStandort.paymentProvider === 'paypal' ? ['paypal'] : [])];
        arrayWithPaymentIconNames = arrayWithPaymentIconNames?.map(iconName => iconName.replace('/', '').replace('klarnaSofort', 'sofort'));
        arrayWithPaymentIconNames = arrayWithPaymentIconNames?.map(iconName => iconName.replace('/', '').replace("depitPayment", 'sepa'));
        arrayWithPaymentIconNames = _.uniq(arrayWithPaymentIconNames);
        let fixedLastGroup = [];
        if (isPaypalService) {
            fixedLastGroup = ["paypal", "sofort", "sepa-abgewickelt", 'visa-mastercard'];
        } else if (isPayOneService) {
            fixedLastGroup = ['sepa', 'mastercard', 'visa'];
        }
        const iconsInLastGroup = arrayWithPaymentIconNames.filter(icon => fixedLastGroup.includes(icon));
        const iconsBeforeLastGroup = arrayWithPaymentIconNames.filter(icon => !fixedLastGroup.includes(icon));
        const sortedIconsBeforeLastGroup = _.sortBy(iconsBeforeLastGroup);
        arrayWithPaymentIconNames = [...sortedIconsBeforeLastGroup, ...fixedLastGroup.filter(icon => iconsInLastGroup.includes(icon))];
        settotalPaymentIcon(arrayWithPaymentIconNames.length);
        return arrayWithPaymentIconNames;
    }, [isPayOneService, isPaypalService, markenStandort]);

    const arrayWithShippingIconNames = useMemo(() => {
        let arrayWithShippingIconNames = _.get(markenStandort, 'stammblatt.versandarten', ['dhl']);
        arrayWithShippingIconNames = arrayWithShippingIconNames.map(iconName => iconName.replace('/', ''));
        arrayWithShippingIconNames = _.sortBy(arrayWithShippingIconNames);
        settotalShippingIcon(arrayWithShippingIconNames.length);
        return arrayWithShippingIconNames;
    }, [markenStandort]);

    return (
        <section className="uk-section uk-section-default">
            <div className="uk-container">
                <div
                    className={classnames(
                        'uk-grid uk-grid-small uk-grid-match uk-child-width-1-1 uk-child-width-1-2@s',
                        markenStandort?.autohauskenner ? 'uk-child-width-1-4@m' : 'uk-child-width-1-3@m'
                    )}
                    data-uk-grid=""
                >
                    {markenStandort?.autohauskenner && (
                        <div>
                            <div className="uk-card uk-card-small uk-card-default uk-card-body uk-text-center">
                                <h3>Partner</h3>
                                <iframe
                                    loading="lazy"
                                    id="autohauskenner"
                                    title="Autohauskenner"
                                    src={markenStandort.autohauskenner}
                                    frameBorder="0"
                                    scrolling="no"
                                    width="100%"
                                    height="250"
                                />
                            </div>
                        </div>
                    )}
                    <div>
                        <div className="uk-card uk-card-small uk-card-default uk-card-body uk-text-center">
                            <h3>Zahlarten</h3>
                            {isPayOneService && !isPaypalService && totalPaymentIcon <= 4 && arrayWithPaymentIconNames.length > 0 && (
                                <div className='uk-flex uk-flex-center'>
                                    {arrayWithPaymentIconNames.filter(icon => icon === 'paypal').map((iconName, index) => {
                                        return <Icon key={index} iconName={iconName} alt={`${iconName?.toLowerCase()}`} />;
                                    })}
                                </div>
                            )}
                            {isPaypalService && totalPaymentIcon > 0 && (() => {
                                const icons = Array.from(new Set(arrayWithPaymentIconNames));
                                const hasSepa = icons.includes('sepa-abgewickelt');
                                const hasVisa = icons.includes('visa-mastercard');

                                const displayIcons = hasSepa && hasVisa
                                    ? icons.filter(icon => icon !== 'sepa-abgewickelt' && icon !== 'visa-mastercard')
                                    : icons;

                                const forceFullWidth = displayIcons.length === 1 || displayIcons.includes('visa-mastercard');
                                const gridClass = forceFullWidth ? 'uk-child-width-1-1' : 'uk-child-width-1-2';

                                return (
                                    <>
                                        <div
                                            className={`uk-grid uk-grid-small uk-width-1-1 ${gridClass} uk-flex uk-flex-center uk-flex-middle`}
                                            data-uk-grid=""
                                        >
                                            {displayIcons.map((iconName, index) => {
                                                const isSpecial = iconName === 'sepa-abgewickelt' || iconName === 'visa-mastercard';

                                                return isSpecial ? (
                                                    <IconWithAbgewikelt
                                                        key={`icon-${index}`}
                                                        iconName={iconName}
                                                        alt={iconName.toLowerCase()}
                                                    />
                                                ) : (
                                                    <Icon
                                                        key={`icon-${index}`}
                                                        iconName={iconName}
                                                        alt={iconName.toLowerCase()}
                                                    />
                                                );
                                            })}
                                        </div>

                                        {hasSepa && hasVisa && (
                                            <div className="uk-grid uk-grid-small uk-width-1-1 uk-child-width-1-1 uk-flex uk-flex-center uk-flex-middle" data-uk-grid="">
                                                <IconWithAbgewikelt
                                                    key="visa-mastercard-sepa"
                                                    iconName="visa-mastercard-sepa"
                                                    alt="visa-mastercard-sepa"
                                                />
                                            </div>
                                        )}
                                    </>
                                );
                            })()}


                            {isPayOneService && !isPaypalService && totalPaymentIcon === 5 ? (
                                <>
                                    <div
                                        className="uk-grid uk-grid-small uk-width-1-1 uk-child-width-1-2 uk-flex uk-flex-center uk-flex-middle"
                                        data-uk-grid=""
                                    >
                                        {arrayWithPaymentIconNames.filter(icon => icon !== 'visa-mastercard').slice(0, 2).map((iconName, index) => (
                                            <Icon key={`row1-${index}`} iconName={iconName} alt={iconName?.toLowerCase()} />
                                        ))}
                                    </div>
                                    <div
                                        className="uk-grid uk-grid-small uk-width-1-1 uk-child-width-1-3 uk-flex uk-flex-center uk-flex-middle"
                                        data-uk-grid=""
                                    >
                                        {arrayWithPaymentIconNames.filter(icon => icon !== 'visa-mastercard').slice(2).map((iconName, index) => (
                                            <Icon key={`row2-${index}`} iconName={iconName} alt={iconName?.toLowerCase()} />
                                        ))}
                                    </div>
                                </>
                            ) : (
                                <div
                                    className={`uk-grid uk-grid-small uk-width-1-1 ${gridClass(totalPaymentIcon)} uk-flex uk-flex-center uk-flex-middle`}
                                    data-uk-grid=""
                                >
                                    {isPayOneService && !isPaypalService && totalPaymentIcon > 0 &&
                                        arrayWithPaymentIconNames
                                            .filter(icon => totalPaymentIcon > 4 || icon !== 'paypal')
                                            .map((iconName, index) => (
                                                <Icon key={index} iconName={iconName} alt={iconName?.toLowerCase()} />
                                            ))
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-small uk-card-default uk-card-body uk-text-center">
                            <h3>Versandart</h3>
                            <div
                                className={`uk-grid uk-grid-small uk-width-1-1 ${gridClass(totalShippingIcon)} uk-flex uk-flex-center uk-flex-middle`}
                                data-uk-grid=""
                            >
                                {arrayWithShippingIconNames.map((iconName, index) => {
                                    return <Icon key={index} iconName={iconName} alt={`${iconName?.toUpperCase()}-Versand`} />;
                                })}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-small uk-card-default uk-card-body uk-text-center">
                            <h3>Sicherheit</h3>
                            <div className="uk-grid uk-grid-small uk-child-width-1-3 uk-flex uk-flex-center uk-flex-middle" data-uk-grid="">
                                <Icon iconName="mastersecure" alt="mastercard-secure" />
                                <Icon iconName="ssl" alt="ssl-secure" />
                                <Icon iconName="verifiedvisa" alt="visa-secure" />
                                <div className="uk-width-1-1">
                                    <p className="uk-text-center uk-margin-small-top">Sichere Zahlung mit SSL-Verschlüsselung</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PaymentColumns;
